export enum DrawingTools {
  POLYGON = 'polygon',
  RECTANGLE = 'rectangle',
  CIRCLE = 'circle',
  NAVIGATE = 'navigate',
}
